import { render, staticRenderFns } from "./CreateKhatma.vue?vue&type=template&id=5550a07a&scoped=true&"
import script from "./CreateKhatma.vue?vue&type=script&lang=js&"
export * from "./CreateKhatma.vue?vue&type=script&lang=js&"
import style0 from "./CreateKhatma.vue?vue&type=style&index=0&id=5550a07a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5550a07a",
  null
  
)

export default component.exports